<template>
    <div class="agent-headshot">
        <img-box
            class="agent-img"
            :src="targetSrc"
            :alt="agent.fullName || $t('common:agent.avatar')"
            :dir="dir"
            :size="size"
            :errorImg="errorImg"
            @click="imgClick"
        >
            <slot name="inner"></slot>
        </img-box>
        <slot></slot>
    </div>
</template>
<script>
const errorImgs = {
    OneByOne: 'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png',
    ThreeByFour: 'https://cdn.chime.me/image/fs/sitebuild/2025117/5/original_26507295-374f-48e2-b93d-e439771031c7.png',
    FiveByThree: 'https://cdn.chime.me/image/fs/sitebuild/2025117/5/original_e82ffebe-fc7f-412a-92a1-d6891ac74094.png'
}
export default {
    emits: ['imgClick'],
    i18next: {
        ns: 'common'
    },
    props: {
        agent: {
            type: Object,
            default: () => ({})
        },
        dir: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default: 0
        },
        useParentDom: {
            type: Boolean,
            default: false
        },
        ratio: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            ratioList: [
                { type: 'OneByOne', ratio: '1:1', value: 1 }, // width : height
                { type: 'ThreeByFour', ratio: '3:4', value: 0.75 },
                { type: 'FiveByThree', ratio: '5:3', value: 1.66 }
            ],
            ratioType: '',
            targetSrc: '',
            resizeObserver: null
        }
    },
    computed: {
        errorImg() {
            return errorImgs[this.ratioType] || errorImgs.OneByOne;
        }
    },
    watch: {
        'agent.headShots'() {
            this.onCalcRatioType()
        },
        'agent.image'() {
            this.onCalcRatioType()
        }
    },
    created() {
        this.ratioType = this.ratioList.find(item => item.ratio === this.ratio)?.type || '';
        this.getTargetImage();
    },
    mounted() {
        let dom = this.$el;
        if (dom) {
            this.resizeObserver = new ResizeObserver(entries => {
                this.calcRatioType(dom);
            });
            try {
                this.resizeObserver.observe(this.$el);
                window.addEventListener('resize', this.calcRatioType(this.$el), false);
            } catch (e) {}
        }
    },
    unmounted() {
        try {
            this.resizeObserver && this.resizeObserver.unobserve(this.$el);
            window.removeEventListener('resize', this.calcRatioType(this.$el));
        } catch (e) {}
    },
    methods: {
        imgClick() {
            this.$emit('imgClick')
        },
        onCalcRatioType() {
            this.$nextTick(() => {
                let dom = this.$el;
                if (dom) {
                    this.calcRatioType(dom);
                }
            })
        },
        calcRatioType(container) {
            if (this.ratio) {
                return;
            }
            let conW = container.offsetWidth;
            let conH = container.offsetHeight;
            if (this.useParentDom) {
                const parentDom = container.parentNode;
                const parentWidth = parentDom.offsetWidth;
                const parentHeight = parentDom.offsetHeight;
                conW = parentWidth;
                conH = parentHeight;
            } 
            if (conW && conH) {
                const conRatio = (conW / conH).toFixed(2);
                const targetItem = this.findClosestRatio(this.ratioList, conRatio);
                this.ratioType = targetItem.type || ''
            } else {
                this.ratioType = ''
            }
            this.getTargetImage()
        },
        getTargetImage() {
            let { headShots, image = '' } = this.agent || {};
            headShots = headShots || {};
            if (this.ratioType && headShots?.['photo' + this.ratioType]) {
                // console.log("🚀 ~ getTargetImage ~ this.ratioType:", this.agent, this.ratioType, headShots?.['photo' + this.ratioType])
                this.targetSrc = headShots['photo' + this.ratioType]
            } else {
                this.targetSrc = headShots.photoOneByOne || headShots.photoThreeByFour || headShots.photoFiveByThree || image
            }
        },
        findClosestRatio(arr, target) {
            return arr.reduce(function(prev, curr) {
                return Math.abs(target - curr.value) < Math.abs(target - prev.value) ? curr : prev;
            });
        },
    }
}
</script>
<style lang="scss">
.agent-headshot {
    width: 100%;
    height: 100%;
    .agent-img {
        width: 100%;
        height: 100%;
    }
}
</style>
